import Link from "next/link";
import { LuScrollText } from "react-icons/lu";

import { APP_NAME_GENERIC, TOKEN_MECHANICS_DOC_URL } from "@/utils/constants";
import { cn } from "@/utils/lib";

import { Button } from "../ui/button";

export const LearnMore = ({
  className,
  textClassName,
  iconClassName,
  iconSize,
}: {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  iconSize?: number;
}) => {
  return (
    <Link href={TOKEN_MECHANICS_DOC_URL} target="_blank">
      <Button
        className={cn("flex items-center gap-x-1 px-0 text-muted", className)}
        variant="link"
      >
        <LuScrollText
          className={cn("text-xs", iconClassName)}
          size={iconSize}
        />
        <span className={cn("text-xs", textClassName)}>
          Learn more about tokens on {APP_NAME_GENERIC}
        </span>
      </Button>
    </Link>
  );
};
